<template>
    <div class="keep-watching-card">
        <img class="keep-watching-card__img" :src="image" alt="" />
        <div class="keep-watching-card__content">
            <h3 class="keep-watching-card__title">{{ truncatedTitle }}</h3>
            <p class="keep-watching-card__description">{{ description }}</p>
            <a class="keep-watching-card__btn" :href="`/aluno/curso/${id}`">
                <i class="pi pi-play"></i>
                <span> Continuar de onde parei </span>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'KeepWatchingCard',
        props: {
            id: {
                type: String,
                required: true,
            },
            image: {
                type: String,
                default: '',
            },
            title: {
                type: String,
                default: 'Continue Assistindo',
            },
            description: {
                type: String,
                default: '',
            },
        },
        computed: {
            truncatedTitle() {
                if (this.title.length > 80) {
                    return this.title.slice(0, 80) + '...';
                }
                return this.title;
            },
        },
        data() {
            return {
                // Define any data properties if needed
            };
        },
    };
</script>

<style scoped>
    .keep-watching-card {
        width: 100%;
        background-color: var(--dash-bg-elevated, #ffffff);
        overflow: hidden;
        border-radius: 16px;
        border: 1px solid var(--dash-border, rgba(15, 23, 42, 0.08));
        box-shadow: 0 4px 24px rgba(15, 23, 42, 0.08);
    }

    .dark .keep-watching-card {
        background-color: var(--dash-bg-elevated, #1a191f) !important;
        border-color: var(--dash-border, rgba(255, 255, 255, 0.08)) !important;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
    }

    .keep-watching-card__img {
        width: 100%;
        height: 240px;
        object-fit: cover;
    }

    .keep-watching-card__content {
        padding: 20px;
        text-align: start;
        max-height: 100%;
    }

    .keep-watching-card__title {
        font-size: 24px;
        font-weight: 700;
        color: var(--dash-text, #111827);
        margin-bottom: 16px;
    }

    .dark .keep-watching-card__title {
        color: var(--dash-text, #f3f4f6);
    }
    .dark .keep-watching-card__description {
        color: var(--dash-text-muted, #b4b1ad) !important;
    }
    .keep-watching-card__description {
        font-size: 16px;
        color: var(--dash-text-muted, #4b5563);
        margin-bottom: 16px;
    }

    .keep-watching-card__btn {
        display: inline-flex;
        padding: 12px 18px;
        background: linear-gradient(135deg, #1ac7d0 0%, #14a8b0 100%);
        color: #0f172a;
        text-decoration: none;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        transition: transform 0.2s, box-shadow 0.2s, filter 0.2s;
        cursor: pointer;
        align-items: center;
        gap: 8px;
        box-shadow: 0 2px 12px rgba(26, 199, 208, 0.35);
    }

    .dark .keep-watching-card__btn {
        color: #0f172a;
    }

    .keep-watching-card__btn:hover {
        filter: brightness(1.05);
        transform: translateY(-1px);
        box-shadow: 0 4px 16px rgba(26, 199, 208, 0.45);
    }

    @media screen and (min-width: 768px) {
        .keep-watching-card {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .keep-watching-card__img {
            order: 2;
            height: 306px;
            width: 46%;
        }

        .keep-watching-card__content {
            order: 1;
            width: 54%;
            padding: 48px;
        }

        .keep-watching-card__title {
            font-size: 32px;
            margin-bottom: 24px;
        }
    }
</style>
